import { MDBCol, MDBRow } from "mdbreact";
import React, { useState } from "react";

import "./ContactForm.scss";

const ContactForm = () => {
	const [showMessageForm, setShowMessageForm] = useState(false);

	//mock data( replace with Actual data in future)
	const ContactData = [
		{
			id: 1,
			name: "xyz",
			phone: 9876543210,
			email: "xyz@gmail.com",
			department: "UI/UX",
		},
		{
			id: 1,
			name: "xyz",
			phone: 9876543210,
			email: "xyz@gmail.com",
			department: "UI/UX",
		},
		{
			id: 2,
			name: "abc",
			phone: 9876543210,
			email: "abc@gmail.com",
			department: "UI/UX",
		},
		{
			id: 3,
			name: "pqr",
			phone: 9876543210,
			email: "pqr@gmail.com",
			department: "UI/UX",
		},
		{
			id: 4,
			name: "klm",
			phone: 9876543210,
			email: "klm@gmail.com",
			department: "UI/UX",
		},
		{
			id: 5,
			name: "rst",
			phone: 9876543210,
			email: "rst@gmail.com",
			department: "UI/UX",
		},
	];

	const handleSendMessageToAllClick = () => {
		setShowMessageForm(true);
	};

	const handleSendClick = () => {
		// Implement send message logic here
		alert("Message sent");
	};

	return (
		<>
			{ContactData.map((contact, index) => (
				<MDBRow key={`contact-data-${index}`} className="mb-3 ml-2">
					<MDBCol size="12" md="5">
						<strong>Name:</strong> {contact.name}
						<br />
						<strong>Phone:</strong> {contact.phone}
					</MDBCol>
					<MDBCol md="1"></MDBCol>
					<MDBCol size="12" md="5">
						<strong>Email:</strong> {contact.email}
						<br />
						<strong>Department:</strong> {contact.department}
					</MDBCol>
				</MDBRow>
			))}

			<MDBRow className="d-flex justify-content-end mr-3 contact">
				<button
					className="btn send-btn"
					onClick={handleSendMessageToAllClick}
				>
					{"Send Message To All"}
				</button>
			</MDBRow>

			{showMessageForm && (
				<>
					<MDBRow className="mt-3 px-2">
						<MDBCol>
							<label>Subject</label>
							<input type="text" className="form-control" />
						</MDBCol>
					</MDBRow>
					<MDBRow className="mt-3 px-2">
						<MDBCol>
							<label>Body</label>
							<textarea
								className="form-control"
								rows="4"
							></textarea>
						</MDBCol>
					</MDBRow>
					<MDBRow className="d-flex justify-content-end mt-3 mr-3 contact">
						<button
							className="btn send-btn"
							onClick={handleSendClick}
						>
							Send
						</button>
					</MDBRow>
				</>
			)}
		</>
	);
};

export default ContactForm;
